import {
    Typography,
    Box,
    Button,
    Card,
} from '@mui/material'
import {
    CardAuth,
    BoxAuthHeading,
    BoxInputs,
    BoxAuthTyp,
    BoxAuthLink,
    CardReg,
    BoxRegTyp,
} from '../AuthForm/style'
import { NavLink, useNavigate  } from 'react-router-dom'
import { FormProvider, useForm } from 'react-hook-form'
import { PasswordAuthFormValues, passwordAuthFormSchema } from './ZodValidationSchema'
import { zodResolver } from '@hookform/resolvers/zod'
import { FormBlock } from '../../../common/FormGenerator'
import { getFormConfig } from './settingsConfig'
import { useLoginUserMutation } from '../../../api'
import { profileApi } from '../../../api/profile'
import { useAppDispatch } from '../../../hooks'
import { useEffect } from 'react'
import { toast } from 'react-toastify'
import { getSafeReturnPath } from '../../../utils/getSafeReturnPath'
import { AuthLegalConsent } from '../AuthLegalConsent'

type FormType = 'otp' | 'password_auth' | 'reg' | 'restore'

interface PasswordAuthFormProps {
    onSwitch: React.Dispatch<React.SetStateAction<FormType>>
    returnTo?: string
}

export const PasswordAuthForm: React.FC<PasswordAuthFormProps> = ({ onSwitch, returnTo }) => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const methods = useForm({
        mode: 'onBlur',
        resolver: zodResolver(passwordAuthFormSchema),
        defaultValues: {
            login: '',
            password: '',
        },
    })

    const [
        loginUser,
        { data: loginData, error, isError: isErrorLoginUser, isSuccess: isSuccessLogin, reset },
    ] = useLoginUserMutation()

    const onSubmit = (data: PasswordAuthFormValues) => {
        loginUser(data)
    }

    useEffect(() => {
        if (isErrorLoginUser) {
            toast.error('При авторизации произошла ошибка')
            reset()
        }
    }, [error, isErrorLoginUser, reset])

    useEffect(() => {
        if (!isSuccessLogin || !loginData) {
            return
        }
        void (async () => {
            try {
                await dispatch(
                    profileApi.endpoints.getProfile.initiate(undefined, { forceRefetch: true }),
                ).unwrap()
                navigate(getSafeReturnPath(returnTo), { replace: true })
            } catch {
                window.location.assign(getSafeReturnPath(returnTo))
            }
        })()
    }, [isSuccessLogin, loginData, returnTo, dispatch, navigate])

    return (
        <FormProvider {...methods}>
            <Box autoComplete="off" component="form" onSubmit={methods.handleSubmit(onSubmit)}>
                <Card variant="primaryCard" sx={CardAuth}>
                    <Typography variant='h2' sx={BoxAuthHeading}>Авторизация по паролю</Typography>
                    <Box sx={BoxInputs}>
                        <FormBlock formFieldConfig={getFormConfig('login')} />
                        <FormBlock formFieldConfig={getFormConfig('password')} />
                    </Box>
                    <Typography sx={BoxAuthTyp}>
                        Вернуться к новому входу?&nbsp;
                        <NavLink
                            to='#'
                            style={BoxAuthLink}
                            onClick={(e) => {
                                e.preventDefault()
                                onSwitch('otp')
                            }}
                        >
                            Войти по коду
                        </NavLink>
                    </Typography>
                    <Button variant="contained" color='primary' type='submit'>
                        Войти
                    </Button>
                </Card>

                <Card variant='primaryCard' sx={CardReg}>
                    <Typography sx={BoxRegTyp}>
                      Для авторизации используйте логин и пароль.
                    </Typography>
                </Card>
                <AuthLegalConsent />
            </Box>
        </FormProvider>
    )
}
